import { ChevronLeft, ChevronRight } from 'lucide-react'

import styles from './Pagination.module.scss'

type PaginationProps = {
  page: number
  pageSize: number
  onPrev: () => void
  onNext: () => void
} & ({ total: number } | { total?: undefined; hasNext: boolean })

const Pagination = (props: PaginationProps) => {
  const { page, pageSize, total, onPrev, onNext } = props
  if (total === 0) return null

  const isFirst = page === 0
  let summary = `Page ${(page + 1).toLocaleString()}`
  let isLast = 'hasNext' in props && !props.hasNext
  if (total !== undefined) {
    // Clamp against ``total`` so a stale-by-one ``page`` (e.g. between data
    // arriving and the caller's clamp effect) can't render "Showing 26–10 of 10".
    const start = Math.min(page * pageSize + 1, total)
    const end = Math.min((page + 1) * pageSize, total)
    summary = `Showing ${start.toLocaleString()}–${end.toLocaleString()} of ${total.toLocaleString()}`
    isLast = end >= total
  }

  return (
    <div className={styles.container}>
      <span className={styles.summary}>{summary}</span>
      <div className={styles.controls}>
        <button
          type="button"
          className={styles.pageButton}
          onClick={onPrev}
          disabled={isFirst}
          aria-label="Previous page"
        >
          <ChevronLeft className={styles.icon} />
          Previous
        </button>
        <button type="button" className={styles.pageButton} onClick={onNext} disabled={isLast} aria-label="Next page">
          Next
          <ChevronRight className={styles.icon} />
        </button>
      </div>
    </div>
  )
}

export default Pagination
